import { render, staticRenderFns } from "./ExpedientSummaryWidget.vue?vue&type=template&id=5a2e8f3e&scoped=true"
import script from "./ExpedientSummaryWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExpedientSummaryWidget.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ExpedientSummaryWidget.vue?vue&type=style&index=0&id=5a2e8f3e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2e8f3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a2e8f3e')) {
      api.createRecord('5a2e8f3e', component.options)
    } else {
      api.reload('5a2e8f3e', component.options)
    }
    module.hot.accept("./ExpedientSummaryWidget.vue?vue&type=template&id=5a2e8f3e&scoped=true", function () {
      api.rerender('5a2e8f3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/widgets/ExpedientWidgets/ExpedientSummaryWidget/ExpedientSummaryWidget.vue"
export default component.exports